export default (m, e, t = 'script', r = 'https://mc.yandex.ru/metrika/tag.js', i = 'ym', k, a) => {
    m[i] =
      m[i] ||
      function (...arguments_) {
        ;(m[i].a = m[i].a || []).push(arguments_)
      }
    m[i].l = 1 * new Date()
    // eslint-disable-next-line no-unused-expressions, no-sequences
    ;(k = e.createElement(t)),
      (a = e.getElementsByTagName(t)[0]),
      (k.async = 1),
      (k.src = r),
      a.parentNode.insertBefore(k, a)
  }
  